import { render, staticRenderFns } from "./ajBatchImport.vue?vue&type=template&id=4bdfdb92&scoped=true"
import script from "./ajBatchImport.vue?vue&type=script&lang=js"
export * from "./ajBatchImport.vue?vue&type=script&lang=js"
import style0 from "./ajBatchImport.vue?vue&type=style&index=0&id=4bdfdb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfdb92",
  null
  
)

export default component.exports